import React from 'react';
import { RotateCw, Sparkles, Lock, Wind, Moon, Volume2 } from 'lucide-react';

export interface CustomTogglesStyle03Props {
  toggles: string[];
  values: Record<string, boolean>;
  disabled?: boolean;
  loading?: boolean;
  onChange: (name: string, value: boolean) => void;
  label?: string;
}

// Toggle icons and labels
const TOGGLE_CONFIG: Record<string, { icon: React.ElementType; label: string }> = {
  AutoDirection: { icon: RotateCw, label: '自動擺動' },
  AirClean: { icon: Sparkles, label: '空氣清淨' },
  Lock: { icon: Lock, label: '鎖定' },
  Ionizer: { icon: Wind, label: '負離子' },
  Swing: { icon: RotateCw, label: '擺動' },
  Sleep: { icon: Moon, label: '睡眠模式' },
  Beep: { icon: Volume2, label: '提示音' }
};

/**
 * CustomToggles Style 03 - Icon Pills
 * Pill-shaped toggle buttons with icons
 */
export const Style03_IconPills: React.FC<CustomTogglesStyle03Props> = ({
  toggles,
  values,
  disabled = false,
  loading = false,
  onChange,
  label = '功能開關'
}) => {
  if (!toggles || toggles.length === 0) return null;

  return (
    <div className="space-y-3">
      <span className="text-sm text-slate-300">{label}</span>
      <div className="flex gap-2">
        {toggles.map((toggle) => {
          const isOn = values?.[toggle] ?? false;
          const config = TOGGLE_CONFIG[toggle] || { icon: Sparkles, label: toggle };
          const Icon = config.icon;

          return (
            <button
              key={toggle}
              onClick={() => onChange(toggle, !isOn)}
              disabled={disabled || loading}
              className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-full text-sm font-medium transition-all ${
                isOn
                  ? 'bg-blue-500 text-white'
                  : 'bg-slate-700/50 text-slate-400 hover:bg-slate-600/50'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              <Icon className="w-4 h-4" />
              {config.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Style03_IconPills;
